import { Component, Input } from '@angular/core';
import { Movie, SquarePromo } from '../../services/Page/page.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from "@angular/material/icon";
import { BookingService } from '../../services/Booking/booking.service';
import { AddComponent } from "../UI/add/add.component";

@Component({
    selector: 'app-poster-card',
    imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    AddComponent
],
    templateUrl: './poster-card.component.html',
    styleUrl: './poster-card.component.scss'
})
export class PosterCardComponent {

    @Input('movie') movie: Movie | undefined

    constructor(
        public bookingService: BookingService,
    ) {

    }

    onBookNow() {
        if (this.movie) {
            this.bookingService.open(this.movie)
        }
    }
}
